export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q03_b.f74c38df.png";